const CompletedIcon = ({ color = '#314158', width = '16px', height = '16px' }) => {
	return (
		<svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#menu-check-circle-clip)">
				<path
					d="M14.5331 6.66764C14.8376 8.16184 14.6206 9.71525 13.9183 11.0688C13.2161 12.4224 12.071 13.4943 10.6741 14.1058C9.27718 14.7174 7.71284 14.8315 6.24196 14.4292C4.77107 14.0269 3.48255 13.1326 2.59127 11.8953C1.7 10.6579 1.25984 9.15246 1.3442 7.62989C1.42856 6.10733 2.03234 4.6597 3.05486 3.52842C4.07737 2.39714 5.45681 1.65059 6.96313 1.41327C8.46946 1.17595 10.0116 1.46221 11.3324 2.2243"
					stroke={color}
					strokeWidth="1.33333"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path d="M6 7.33464L8 9.33464L14.6667 2.66797" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
			</g>
			<defs>
				<clipPath id="menu-check-circle-clip">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default CompletedIcon;

